import React from 'react';
import Styles from './error-styles.scss';
const Error = ({ error, reload }) => {
    return (React.createElement("div", { className: Styles.errorWrap },
        React.createElement("span", { "data-testid": "error" }, error),
        React.createElement("button", { "data-testid": "reload", onClick: reload }, "Try again")));
};
export default Error;
